import React, { useState, useEffect } from 'react'
import MomentUtils from '@date-io/moment'
import { makeStyles } from '@material-ui/core/styles'
import {
  KeyboardDatePicker,
  Day,
  MuiPickersUtilsProvider
} from '@material-ui/pickers'
import moment from 'moment'

const useStyles = makeStyles({
  hightLightDate: {
    position: 'relative',
    '&:before': {
      top: '2px',
      right: '7px',
      zIndex: 1,
      position: 'absolute',
      content: '"◥"',
      fontSize: '12px',
      color: '#8BC34A'
    }
  },
  datepickerStyle: {
    width: '100%'
  }
})
function CustomMuiDatePicker (props) {
  const classes = useStyles()
  const [, setSelectedDate] = useState()
  const [, stateUpdate] = useState('')

  useEffect(() => {
    props.linkStateUpdater(stateUpdate)
  }, [])
  const handleDateChange = date => {
    props.dateChange(date)
    setSelectedDate(date)
  }
  const onMonthChange = date => {
    props.monthChange(date)
  }
  const renderDay = (day, selectedDate, _, dayElement) => {
    const selected = day.diff(selectedDate, 'days') === 0
    const current = day.diff(moment(), 'days') === 0
    const dis = day.format('D')
    return props.getHiglightDates().includes(day.format('YYYY-MM-DD')) ? (
      <div className={classes.hightLightDate}>
        <Day selected={selected} current={current}>
          {dis}
        </Day>
      </div>
    ) : (
      dayElement
    )
  }
  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <KeyboardDatePicker
        className={classes.datepickerStyle}
        value={props.getSelectedDate()}
        onChange={date => handleDateChange(date)}
        variant='inline'
        format='DD/MM/YYYY'
        disableToolbar
        autoOk
        InputAdornmentProps={{ position: 'end' }}
        onMonthChange={onMonthChange}
        renderDay={renderDay}
      />
    </MuiPickersUtilsProvider>
  )
}
export default CustomMuiDatePicker
